import React, { useEffect, useState } from 'react';

const ReportTrackerButton = ({ studyInstanceUid }) => {
  const [buttonLabel, setButtonLabel] = useState('Loading...'); // Default label during fetch

  useEffect(() => {
    if (studyInstanceUid) {
      fetch(
        `https://studies.clarify-pacs.com/fetch_reportTrackerButtonStatus.php?studyInstanceUid=${studyInstanceUid}`

        // `http://38.242.140.57/pacs/fetch_reportTrackerButtonStatus.php?studyInstanceUid=${studyInstanceUid}`
      )
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.error) {
            console.error('Error:', data.error);
            setButtonLabel('No Report');
          } else {
            setButtonLabel(data.reportTracker_button || 'No Report..'); // Use fetched value or fallback
          }
        })
        .catch(error => {
          console.error('TrackerButton Error fetching data:', error);
          setButtonLabel('No Report*');
        });
    }
  }, [studyInstanceUid]); // Trigger fetch when UID changes

  // Determine background color based on the label
  const getButtonBackgroundColor = () => {
    switch (buttonLabel) {
      case 'In Progress':
        return '#0087ed'; // Blue
      case 'View Report':
        return '#38c719'; // Green
      case 'No Report':
        return '#5f5a5aff'; // Dark
      case 'Scheduled':
        return '#dcdc03ff'; // yellow
      case 'Re-Upload':
        return '#f45454ff'; // reddish
      case 'Erased':
        return '#5f5a5aff'; // grey
      default:
        return '#5f5a5aff'; // Grey  DEFAULT
    }
  };

  return (
    <button
      name="sigButton"
      disabled={buttonLabel !== 'View Report'} // Disable unless it's "View Report"
      style={{
        position: 'relative',
        height: '30px',
        width: '100%',
        borderColor: '#000000',
        borderWidth: '1px',
        borderRadius: '4px',
        borderStyle: 'solid',
        //color: '#f0f5f5', //Text colour white
        color: '#000000', //Text colour Black
        backgroundColor: getButtonBackgroundColor(), // Dynamic background color based on label
        padding: '0.5rem',
        margin: '0.1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {buttonLabel}
    </button>
  );
};

export default ReportTrackerButton;
